<div class="mat-card">
    <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="h1 pr-16">Categorías</div>
    </div>

    <mat-tree
        [dataSource]="dataSource"
        [treeControl]="treeControl"
        class="example-tree"
    >
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <li class="mat-tree-node cursor-pointer" (click)="buscar(node)">
                <!-- use a disabled button to provide padding for tree leaf -->
                <button mat-icon-button disabled></button>
                <small
                    ><span>- {{ node.descripcion }}</span></small
                >
            </li>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <li>
                <div class="mat-tree-node">
                    <button
                        mat-icon-button
                        matTreeNodeToggle
                        [attr.aria-label]="'Toggle ' + node.descripcion"
                    >
                        <mat-icon class="mat-icon-rtl-mirror">
                            {{
                                treeControl.isExpanded(node)
                                    ? "expand_more"
                                    : "chevron_right"
                            }}
                        </mat-icon>
                    </button>
                    <span matTreeNodeToggle class="cursor-pointer">{{
                        node.descripcion
                    }}</span>
                </div>
                <ul
                    [class.example-tree-invisible]="
                        !treeControl.isExpanded(node)
                    "
                >
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </li>
        </mat-nested-tree-node>
    </mat-tree>
    <br />
</div>
